export default __webpack_public_path__ + "static/media/gangnam-gu.5efd2217.jpg";